import { JSX, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDialog } from "../../../components/Dialogs/dialog-base";
import { DeliveryTypeOption } from "../useOrderConfirmationEditViewModel";
import { useProfileContext } from "../../../../contexts/ProfileContext";
import { OrderDialog } from "./OrderDialog";
import { DeliveryType } from "../../../../core/models/entities/Order";

interface Props {
  component: JSX.Element;
  open: () => void;
}

export function useDeliveryTypeOrderDialog({
  onContinue,
  onCancel,
  type,
}: {
  onContinue: () => Promise<void>;
  onCancel?: () => void;
  type: DeliveryTypeOption;
}): Props {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [toggle, setToggle] = useState<boolean>(false);

  const dialog = useDialog();
  const { profile } = useProfileContext();

  function handleSubmit() {
    setLoading(true);
    onContinue().finally(() => {
      setLoading(false);
      setToggle(false);
      dialog.closeDialog();
    });
  }

  function handleToggle() {
    setToggle(!toggle);
  }

  function handleCancel() {
    if (onCancel) onCancel();
    dialog.closeDialog();
  }

  // TODO Hardcoded percentage surcharge, which is DEFINITELY not the right way.
  const getDeliveryPercentageSurcharge = () => {
    switch (type.type) {
      case DeliveryType.Express24:
        return 100;
      case DeliveryType.Express48:
        return 50;
      case DeliveryType.Express72:
        return 25;
      default:
        return 0;
    }
  };

  const geExpressDeliveryType = () => {
    switch (type.type) {
      case DeliveryType.Express24:
        return t("orderConfirmation.deliveryExpress24");
      case DeliveryType.Express48:
        return t("orderConfirmation.deliveryExpress48");
      case DeliveryType.Express72:
        return t("orderConfirmation.deliveryExpress72");
      default:
        return t("orderConfirmation.standardDelivery");
    }
  };

  const p = getDeliveryPercentageSurcharge();
  const e = geExpressDeliveryType();

  return {
    component: (
      <>
        <OrderDialog
          dialogVm={dialog}
          onToggle={handleToggle}
          onSubmit={handleSubmit}
          loading={loading}
          onCancel={handleCancel}
          toggle={toggle}
          title={type.title}
          termsText=""
          explanation={t("orderConfirmation.deliveryTypeFeeExplanation", {
            type: e,
            percent: p,
          })}
        />
      </>
    ),
    open: dialog.openDialog,
  };
}
